export default __webpack_public_path__ + "299b0c2c2d8b0b5f3eef523133830dc2.png";